import { call, put, takeLatest } from "redux-saga/effects";

// Login Redux States
import { ADD_ROLE,GET_ROLE,EDIT_ROLE } from "./actionTypes";

import { addRole ,getRole,editRole} from "../../helpers/UAM/role.helper";
import { allRoles } from "../actions";

function* addRoles({ payload: { role,history } }) {
  try {
    const responseFromAPI =  yield call(addRole, role);
    if(responseFromAPI.code ==201 ){
      history('/admin/roles');
    } 
  
  } catch (error) {
    console.log("error", error)
  }
}

function* getRoles({ payload: { role} }) {
    try {
      const responseFromAPI =  yield call(getRole,role);
      if(responseFromAPI.code ==200 ){
          const {data} = responseFromAPI
          yield put(allRoles({data}));
      }
    
    } catch (error) {
      console.log("error", error)
    }
  }

  function* editRoles({ payload: { role,history } }) {
    try {
      const responseFromAPI =  yield call(editRole, role);
      if(responseFromAPI.code ==201 ){
        history('/admin/roles');
      }
    
    } catch (error) {
      console.log("error", error)
    }
  }



 
function* roleSaga() {
    yield takeLatest(ADD_ROLE, addRoles);
    yield takeLatest(GET_ROLE, getRoles);
    yield takeLatest(EDIT_ROLE, editRoles);
   
  }


export default roleSaga;
